import React from "react";
import styled from "styled-components";
import ColorPickerField from "../../../components/ColorPickerField";
import { Caption1 } from "../../../styles/typography";
import { getOptionHex, getOptionLabel } from "../optionsConfig";

const MatchHint = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 8px;
  background: rgb(${(p) => p.theme.colors.offWhite});
`;

const MatchSwatch = styled.span`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  flex: 0 0 auto;
  background: ${(p) => p.$hex};
  box-shadow: ${(p) => p.theme.shadows.shadow100()};
`;

/**
 * @param {{
 *  options: {id:string,label:string,hex?:string}[],
 *  swatchImageUrl?: string,
 *  required?: boolean,
 *  value: string,
 *  onChange: (value:string)=>void,
 *  showError?: boolean,
 *  matchColorId?: string,
 * }} props
 */
const ColorPickerStep = ({
  options,
  swatchImageUrl,
  required,
  value,
  onChange,
  showError,
  matchColorId,
}) => {
  const errorCondition = required && showError && !value;
  const matchLabel = matchColorId
    ? getOptionLabel(options, matchColorId)
    : null;
  const matchHex = matchColorId ? getOptionHex(options, matchColorId) : null;

  return (
    <>
      {matchLabel && (
        <MatchHint>
          <MatchSwatch $hex={matchHex} />
          <Caption1>
            Your front cover color: <strong>{matchLabel}</strong>
          </Caption1>
        </MatchHint>
      )}
      <ColorPickerField
        label="Color"
        options={options}
        swatchImageUrl={swatchImageUrl}
        value={value}
        onChange={onChange}
        errorCondition={errorCondition}
      />
    </>
  );
};

export default ColorPickerStep;
